import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blue: {
		id: 'dashboard-common.blue',
		defaultMessage: 'Blue',
		description: 'HIGHLIGHT COLOR - tooltip for Blue',
	},
	red: {
		id: 'dashboard-common.red',
		defaultMessage: 'Red',
		description: 'HIGHLIGHT COLOR - tooltip for Red',
	},
	yellow: {
		id: 'dashboard-common.yellow',
		defaultMessage: 'Yellow',
		description: 'HIGHLIGHT COLOR - tooltip for Yellow',
	},
	green: {
		id: 'dashboard-common.green',
		defaultMessage: 'Green',
		description: 'HIGHLIGHT COLOR - tooltip for Green',
	},
	teal: {
		id: 'dashboard-common.teal',
		defaultMessage: 'Teal',
		description: 'HIGHLIGHT COLOR - tooltip for Teal',
	},
	purple: {
		id: 'dashboard-common.purple',
		defaultMessage: 'Purple',
		description: 'HIGHLIGHT COLOR - tooltip for Purple',
	},
	gray: {
		id: 'dashboard-common.gray',
		defaultMessage: 'Gray',
		description: 'HIGHLIGHT COLOR - tooltip for Gray',
	},
	white: {
		id: 'dashboard-common.white',
		defaultMessage: 'White',
		description: 'HIGHLIGHT COLOR - tooltip for White',
	},
});
